<template>
  <div class="box">
    <div class="head-box">
      <b>填写信息</b> Fill in information
      <span>填写信息 > 支付 > 报名成功</span>
    </div>
    <div v-if="joinList.length > 0" style="width:1200px;overflow: hidden;">
      <h3 style="color:gray;margin-top:10px;">已报人员</h3>
      <div v-for="(item, index) in joinList" :key="index" style="width:350px;border:1px dashed #ccc;float:left;padding:10px;position: relative;">
        <h3>{{ item.projectName }}</h3>
        <img :src="item.image" style="width:60px;height:80px;border-radius:5px;float: left;"/>
        &ensp;&ensp; 姓名：{{ item.name }}<br/>
        &ensp;&ensp; 手机号码：{{ item.mobile }}<br/>
        &ensp;&ensp; 身份证号：{{ item.card }}<br/>
        <span v-if="item.money > 0 && item.chargeMode === 'project'">
          &ensp;&ensp;
          <span v-if="item.status === 1" style="color:green;"> 已支付√</span>
          <span v-else>
            支付金额：<b style="color:red;">&yen;{{ item.money }}</b>
            <a-button size="small" type="primary" @click="toPay(item)">
              去支付
            </a-button>
          </span>
        </span>
        <span v-if="item.calMoney > 0 && item.chargeMode === 'people'">
          &ensp;&ensp;
          <span v-if="item.status === 1" style="color:green;"> 已支付√</span>
          <span v-else>
            支付金额：<b style="color:red;">&yen;{{ item.calMoney }}</b>
            <a-button size="small" type="primary" @click="toPay(item)">
              去支付
            </a-button>
          </span>
        </span>
        <a-popconfirm
            title="确定要删除吗?"
            @confirm="() => deleteJoin(item.id)"
          >
          <a-icon type="delete" style="position: absolute;right: 10px;top: 10px;"/>
        </a-popconfirm>
      </div>
    </div>
    <div style="height:400px;width: 400px;margin: 20px auto;">
      <div style="width:150px;height:250px;float:left;">
        <upload ref="upload" :length="1" :imgs="image" @uploadSuccess="uploadSuccess" :cutImg="true" uploadTest="上传证件照" :fixedNumber="[5,7]"></upload>
      </div>
      <div><a-input size="large" v-model="formPost.name" placeholder="请输入姓名" style="width:250px;"/></div>
      <div style="margin-top:20px;"><a-input size="large" v-model="formPost.mobile" placeholder="请输入手机号" style="width:250px;"/></div>
      <div style="margin-top:20px;"><a-input size="large" v-model="formPost.card" placeholder="请输入身份证号" style="width:250px;"/></div>
      <div style="margin-top:20px;">
        <a-select style="width: 250px" size="large" v-model="formPost.projectId" placeholder="请选择报名项目">
          <a-select-option :value="item.id" v-for="(item, index) in projectList" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </div>
      <div style="margin-top:20px;">
        <a-button type="primary" @click="submit" size="large" style="width:250px;background:#244e8f;border:1px solid #244e8f;">
          提交
        </a-button>
      </div>
      <PayQrCode ref="payQrCode" @paySuccess="paySuccess"/>
    </div>
  </div>
</template>

<script>
import Upload from '@comm/upload/Upload'
import matchFun from '@comm/utils/matchFun'
import PayQrCode from './PayQrCode'
export default {
  name: 'ExaminHead',
  components: {
    Upload,
    PayQrCode
  },
  data () {
    return {
      matchFun,
      image: [],
      formPost: {
        image: '',
        name: '',
        mobile: '',
        card: '',
        projectId: undefined,
        pointId: this.$route.query.id,
        programId: this.$route.query.programId
      },
      projectList: [],
      joinList: []
    }
  },
  created: function () {
    this.findData()
    this.findProject()
  },
  methods: {
    findData () {
      this.$api.examin.examinJoinList({pointId: this.$route.query.id}).then(res => {
        if (res.status === 0) {
          this.joinList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    clearData () {
      this.image = []
      this.formPost = {
        image: '',
        name: '',
        mobile: '',
        card: '',
        projectId: undefined,
        pointId: this.$route.query.id,
        programId: this.$route.query.programId
      }
    },
    findProject () {
      this.$api.examin.examinProjectList({pointId: this.$route.query.id}).then(res => {
        if (res.status === 0) {
          this.projectList = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    uploadSuccess (e) {
      this.image = e
      if (this.image.length > 0) {
        this.formPost.image = this.image[0].url
      } else {
        this.formPost.image = ''
      }
    },
    submit () {
      if (this.formPost.image === '') {
        this.$message.error('请上传证件照（头像）')
        return
      }
      if (this.formPost.name === '') {
        this.$message.error('请输入姓名')
        return
      }
      if (this.formPost.mobile === '') {
        this.$message.error('请输入手机号')
        return
      }
      if (!matchFun.phoneFun(this.formPost.mobile)) {
        this.$message.error('手机号码不正确')
        return
      }
      if (this.formPost.card === '') {
        this.$message.error('请输入身份证号')
        return
      }
      if (this.formPost.projectId === undefined) {
        this.$message.error('请选择项目')
        return
      }
      this.$api.examin.examinJoinAdd(this.formPost).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.clearData()
          this.findData()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    deleteJoin (id) {
      this.$api.examin.examinJoinDel({id: id}).then(res => {
        if (res.status === 0) {
          this.$message.success('成功')
          this.findData()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    toPay (item) {
      this.$api.examin.examinCreateOrder({joinId: item.id}).then(res => {
        if (res.status === 0) {
          this.$refs.payQrCode.show(res.data)
        } else {
          this.$message.error(res.msg)
          this.findData()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    paySuccess () {
      this.findData()
    }
  }
}
</script>

<style lang="scss" scoped>
.box{
  width: 1200px;
  margin: 0 auto;
}
.head-box{
  font-size: 18px;
  color: black;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid rgb(235, 234, 234);
}
.head-box span{
  float: right;
  font-size: 12px;
  color: gray;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/ActivitySign.vue